import { checkupRouteNames } from "@/application/router/checkup";
import type { NavigationHookAfter } from "vue-router";
import { isCheckupRoute } from "@/application/router/utils/utils";
import { checkupStatusGuard } from "@/application/router/guards/checkupStatusGuard";
import { TrackEventCategory } from '@/application/utils/tracking/events';
import { scrollAppMainTop } from "@/application/utils/scrolling";
import { useTagManager } from '@demv_systems/feu-tag-manager';

export const checkupAfterGuard: NavigationHookAfter = (to, from, failure) => {

  // this tracks if a user is leaving the checkup inside the vue app ('Absprung intern').
  // It is not tracking if the user is closing the tab or browser.
  if (isCheckupRoute(from, checkupRouteNames) && !to.path.includes('/check-up')) {

    useTagManager().push({
      event: TrackEventCategory.CHECKUP,
      action: from.name === 'Bestaetigung' ? 'Navigation nach Abschluss' : 'Absprung intern',
      name: `von: ${from.path} zu: ${to.path}`,
    })
  }

  if (isCheckupRoute(to, checkupRouteNames) && !checkupStatusGuard(to, from, failure)) {
    return false;
  }

  scrollAppMainTop();

  return true;
}
